import { apiClient } from '@shared/infrastructure/http';

interface DeclarationDTO {
  idDeclaration: string;
  type: 'CNSS' | 'ITS';
  mois: number;
  annee: number;
  statut: 'BROUILLON' | 'VALIDE' | 'TRANSMIS';
  montantTotal: number;
  nombreEmployes: number;
  lignes: Array<{ nomEmploye: string; prenomEmploye: string; montant: number }>;
  dateGeneration: string;
  dateValidation: string | null;
  dateTransmission: string | null;
}

const BASE = '/api/v1/paie/declarations';

export const declarationsApi = {
  cnss: (annee: number, mois: number) =>
    apiClient.get<DeclarationDTO>(`${BASE}/cnss/${annee}/${mois}`).then(r => r.data!),

  its: (annee: number, mois: number) =>
    apiClient.get<DeclarationDTO>(`${BASE}/its/${annee}/${mois}`).then(r => r.data!),

  lister: (params?: { annee?: number; type?: string }) => {
    const qs = new URLSearchParams();
    if (params?.annee) qs.append('annee', String(params.annee));
    if (params?.type) qs.append('type', params.type);
    const url = qs.toString() ? `${BASE}?${qs}` : BASE;
    return apiClient.get<DeclarationDTO[]>(url).then(r => r.data ?? []);
  },

  validerCNSS: (annee: number, mois: number) =>
    apiClient.post<void>(`${BASE}/cnss/${annee}/${mois}/valider`, {}).then(r => r.data),

  validerITS: (annee: number, mois: number) =>
    apiClient.post<void>(`${BASE}/its/${annee}/${mois}/valider`, {}).then(r => r.data),

  marquerTransmis: (idDeclaration: string) =>
    apiClient.post<void>(`${BASE}/${idDeclaration}/transmis`, {}).then(r => r.data),
};
